module.exports = __webpack_public_path__ + "img/head.57dff54c.png";